import React, { Component, Fragment } from "react";
import { getSdk } from "../../services/sdkService";
import { withFocusable, Text, Loading, Button, Modal } from "../../services/visualLibraryService";
import {
  HeadingStyled,
  HeadingNoContentStyled,
  NoContentStyled,
  ButtonStyled,
  SecondaryMenuStyled,
  HeadingWrapper
} from "./styled/Styled";
import { TypedCarouselStyled } from "../../styles/shared-styles";
import { playHandler, play } from "../../utils/mediaDataRetrieval";
import { goToDetailPage } from "../../utils/goToDetailPage";
import { getSpSportsPackageDisplayName, isSpSportsAddonContent } from "../../services/sportPackageService";
import {
  showChannelSubscriptionErrorPopupNew,
  isUserSubscribedToChannel,
  isAddonContent,
  showSportPackageSubscriptionErrorPopup,
  isUserSubscribedToSpSportsChannel,
  isStandAloneAddon,
  isMainPackageAddOn,
  getAddOnByName,
  T20ParentAddOn,
  isT20ParentSubscribed,
  isT20AddOn,
  isCricketAddOn,
  isT20ChildSubscribed,
  CricChildAddOn,
  isCricketAcquiresFrom
} from "../../utils/subscriptionUtils";
import getTitlesFormattedForCarousels from "../../utils/getTitlesFormattedForCarousels";
import { i18n } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { getAppState, withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { getInternetConnectivityModalConfig } from "../../errors/utils";
import { getGlobalButtonInfo, getGlobalButtonFocusPath } from "../../errors/globalButtons";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { config } from "../../config/config";
import { isAccessLimitedByParentalLevel } from "../../services/parentalControlService";
import { showInvalidStatusModal, showForceLogoutError } from "../../services/modalsService";
import { starz1 as Theme } from "starz-visual-themes";
import { makeAddOnsDeep } from "../../utils/addOnsUtil";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";

const WATCHLIST = "watchlist";
const MYSTARZLIST = "mystarzlist";
const PAGE = "myLibrary";
const PLAY_FROM_LABEL = "cw_my_library";
const defaultFocusPath = "watchlistCarousel";
const MOVIES = "movies";
const SERIES = "series";
const LAYOUT = "layout";
const DEEP = "deep";
const TypedCarouselFocus = withFocusable(TypedCarouselStyled);
const ButtonFocus = withFocusable(ButtonStyled);
const ButtonModalFocus = withFocusable(Button);
let CONTINUE_WATCHING;
let carouselSettings;
let medialistConfig;

function showNoContent(title, fn, isAccessLimitedByParentalLevel, hasFilterApplied) {
  return (
    <NoContentStyled>
      {title && <HeadingNoContentStyled rank={2} text={title} />}
      <Text text={i18n.get("pages.myLibrary.emptyList")} />
      {!isAccessLimitedByParentalLevel && !hasFilterApplied && (
        <Fragment>
          <Text text={i18n.get("pages.myLibrary.whatToWatch")} />
          <Text text={`${i18n.get("pages.myLibrary.checkOurLatest")}:`} />
          <ButtonFocus
            label={i18n.get("global.media.movies")}
            focusPath={"buttonMoviesPath"}
            onClick={() => {
              fn(MOVIES);
            }}
            size="small"
          />
          <ButtonFocus
            label={i18n.get("global.media.series")}
            focusPath={`${title ? title : ""}buttonSeriesPath`}
            onClick={() => {
              fn(SERIES);
            }}
            size="small"
          />
        </Fragment>
      )}
    </NoContentStyled>
  );
}

class MyLibraryPage extends Component {
  constructor(props) {
    super(props);
    CONTINUE_WATCHING = i18n.get("pages.myLibrary.continueWatching");
    carouselSettings = {
      watchlist: {
        type: WATCHLIST,
        title: CONTINUE_WATCHING,
        name: CONTINUE_WATCHING
      },
      mystarzlist: {
        type: LAYOUT,
        title: i18n.get("pages.myLibrary.myWatchlist"),
        name: WATCHLIST
      }
    };
    medialistConfig = {
      scope: DEEP,
      pageSize: config.get().mediaListPageSize || 999 // Max results limited by spx
    };
    this.sections = {};
    this.carousels = {};
    this.videoConfig = {};
    this.play4KModalFocusPath = null;
    this.playFromLabel = PLAY_FROM_LABEL;
    this.isMagicRemoteActive = false;
    this.onChangeItem = this.onChangeItem.bind(this);
    this.onClickButton = this.onClickButton.bind(this);
    this.loadCarousel = this.loadCarousel.bind(this);
    this.loadData = this.loadData.bind(this);
    this.getInitialSlide = this.getInitialSlide.bind(this);

    this.onClickPoster = this.onClickPoster.bind(this);

    this.onLeft = this.onLeft.bind(this);
    this.onRight = this.onRight.bind(this);
    this.onEnterPlay = this.onEnterPlay.bind(this);
    this.onBack = this.onBack.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.close4KModal = this.close4KModal.bind(this);
    //this.setFilter = this.setFilter.bind(this);
    this.state = {
      isLoading: false,
      mystarzlist: null,
      watchlist: null,
      isEmpty: false,
      modal4K: false,
      didPlayerLaunch: false,
      isLoading: false
    };
    this.userWatchlist = {};
    this.userStarzlist = {};
    this.filterMenu = null;
    this.filtersMenuSelectedIndex = 0;
    this.hasFilterApplied = false;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.isLoading !== this.state.isLoading ||
      nextProps.currentFocus !== this.props.currentFocus ||
      nextState.isEmpty !== this.state.isEmpty ||
      nextState.mystarzlist !== this.state.mystarzlist ||
      nextState.watchlist !== this.state.watchlist ||
      nextState.modal4K !== this.state.modal4K ||
      nextState.isLoading !== this.state.isLoading
    );
  }
  componentDidUpdate() {
    this.isMagicRemoteActive = getSdk().systemManager.application.checkMagicRemote();
  }

  componentWillUnmount() {
    this.props.resumeNavigation();
    this.props.stateActions.setCarouselItemFocus(0);
  }

  onClickPoster(itemIndex, type) {
    this.sections[type].goTo(itemIndex);
    setTimeout(() => {
      this.handleEnter(type);
    }, 100);
  }

  onBack() {
    if (getAppState().globalModal) {
      this.props.stateActions.hideGlobalModal();
      return false;
    }
    if (this.state.modal4K) {
      // Close 4K prompt.
      this.close4KModal();
    } else if (this.state.didPlayerLaunch) {
      // Cancel player launch
      this.setState({ didPlayerLaunch: false });
      this.props.resumeNavigation();
    } else {
      return false;
    }
    return true;
  }

  onEnterPlay(is4K = false) {
    if (this.state.didPlayerLaunch) {
      return;
    }
    this.setState({ didPlayerLaunch: true });
    play.bind(this, is4K)();
    this.props.pauseNavigation();
  }

  onChangeItem(index) {
    this.props.stateActions.setCarouselItemFocus(index);
  }

  onClickButton(section) {
    this.props.history.push({
      pathname: `/${section}`
    });
  }

  onLeft(type) {
    this.sections[type].left();
  }

  onRight(type) {
    this.sections[type].right();
  }

  getInitialSlide(type) {
    if (type === WATCHLIST) {
      return 0;
    }
    return this.props.initialFocus !== `${type}Carousel` ? 0 : this.props.applicationState.focusedCarouselItemIndex;
  }

  loadCarousel(list, type) {
    if (list && list.titles && list.titles.length > 0) {
      const carouselType = carouselSettings[type].type;
      return (
        <TypedCarouselFocus
          onClickPoster={i => this.onClickPoster(i, type)}
          type={carouselType}
          items={getTitlesFormattedForCarousels.call(this, carouselType, list.titles)}
          title={carouselSettings[type].title}
          focusPath={`${type}Carousel`}
          initialSlide={this.getInitialSlide(type)}
          innerRef={carouselRef => {
            this.carousels[type] = carouselRef;
          }}
          onRef={ref => (this.sections[type] = ref)}
          slideMargin={Theme.components.carousel.slideMargin.layout}
          onEnterPress={this.handleEnter.bind(this, type)}
          onChangeItem={this.onChangeItem}
          MagicRemoteStatus={this.isMagicRemoteActive}
          marginBottom={props => props.theme.spacing.medium}
          onLeft={this.onLeft.bind(this, type)}
          onRight={this.onRight.bind(this, type)}
          direction={i18n.getDirection()}
        />
      );
    } else {
      return showNoContent(
        carouselSettings[type].title,
        this.onClickButton,
        isAccessLimitedByParentalLevel(),
        this.hasFilterApplied
      );
    }
  }

  async handleEnter(carouselName) {
    const {
      applicationState: { userAccountStatus, addons }
    } = this.props;
    const videoData = this.sections[carouselName].handleAction();
    const { id, tagList, progress, seriesId, addonContent } = videoData;
    const currentAddOn = getAddOnByName(addonContent);
    this.videoConfig = {
      id,
      tagList,
      progress,
      seriesId,
      titleId4K: videoData["4kProgramId"]
    };
    if (carouselName === WATCHLIST) {
      if (!isUserAccountActive(userAccountStatus) && !isAddonContent(addonContent)) {
        return showInvalidStatusModal.call(this);
      }
      if (isCricketAddOn(addonContent) && isCricketAcquiresFrom(addonContent)) {
        if (!isUserSubscribedToChannel(addons, addonContent) && isT20ChildSubscribed(addonContent)) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, currentAddOn.displayName);
        } else if (!isUserSubscribedToChannel(addons, addonContent) && !isT20ChildSubscribed(addonContent)) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, `${currentAddOn.displayName} & ${CricChildAddOn(addonContent)?.displayName}`);
        }
      } else if (isT20AddOn(addonContent)) {
        if (!isUserSubscribedToChannel(addons, addonContent) && isT20ParentSubscribed(addonContent)) {
          /// if parent is subscribed but t20 is not then only show t20 error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, currentAddOn.displayName);
        } else if (!isUserSubscribedToChannel(addons, addonContent) && !isT20ParentSubscribed(addonContent)) {
          /// if parent and t20 are not subscribed then show t20 + Cricket error
          return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, `${T20ParentAddOn(addonContent)?.displayName} & ${currentAddOn.displayName}`);
        }
      } else {
          if (isMainPackageAddOn(addonContent) && isSpSportsAddonContent(addonContent) && !isUserSubscribedToSpSportsChannel(addons, addonContent)) {
            return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, getSpSportsPackageDisplayName());
          }
          if (!isMainPackageAddOn(addonContent) && !isStandAloneAddon(addonContent) && isSpSportsAddonContent(addonContent) && !isUserSubscribedToSpSportsChannel(addons, addonContent)) {
            return showSportPackageSubscriptionErrorPopup.call(this, this.closeModal, getSpSportsPackageDisplayName());
          }
          if (!isUserSubscribedToChannel(addons, addonContent)) {
            return showChannelSubscriptionErrorPopupNew.call(this, this.closeModal);
          }
        }

      this.setState({
        isLoading: true
      }, async () => {
        const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, addonContent);
        this.setState({ isLoading: false });
        if (!isThisDeviceSupported) {
          return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
        }

        trackEvent(
          "continue watching-my library",
          `play-${this.sections[carouselName].selectedIndex + 1}`,
          seriesId || id
        );
        playHandler.call(this, videoData);
      });

    } else {
      trackEvent("my watchlist-my library", `click-${this.sections[carouselName].selectedIndex + 1}`, seriesId || id);
      goToDetailPage.call(this, { id, tagList, sectionName: PAGE.toLowerCase() });
    }
  }

  closeModal() {
    const {
      stateActions: { hideGlobalModal },
      setFocus
    } = this.props;
    hideGlobalModal();
    setFocus(defaultFocusPath);
  }

  async loadData(callback) {
    try {
    const sdk = await getSdk();
    const { stateActions, setFocus, history } = this.props;
    const fields = "id,title,thumbnails,tags,tagIds,peg$AddonContent";
    const watchlist = sdk.mediaManager.getUserMediaLists(
      {
        ...medialistConfig,
        maxSeriesEpisodes: 1,
        listName: WATCHLIST,
        fields: `${fields},seriesId,tvSeasonNumber,tvSeasonEpisodeNumber,description,shortDescription,guid,media.expirationDate,media.availableDate,media.content.releases.pid,media.content.releases.url,media.content.assetTypes,media.content.streamingUrl,media.content.duration,peg$FourkProgramId`
      },
      !getAppState().isOnline
    );

    const mystarzlist = sdk.mediaManager.getUserMediaLists(
      {
        ...medialistConfig,
        fields,
        listName: MYSTARZLIST
      },
      !getAppState().isOnline
    );
    Promise.all([watchlist, mystarzlist])
      .then(result => {
        this.userWatchlist = result[0];
        this.userStarzlist = result[1];
        this.setState(
          {
            watchlist: this.userWatchlist.media_lists[0] || [],
            mystarzlist: this.userStarzlist.media_lists[0] || [],
            isEmpty:
              (!this.userWatchlist.media_lists.length || !this.userWatchlist.media_lists[0].titles.length) &&
              (!this.userStarzlist.media_lists.length || !this.userStarzlist.media_lists[0].titles.length)
          },
          callback
        );
      })
      .catch(error => {
        const retry = () => {
          stateActions.hideGlobalModal();
          this.loadData();
        };

        const back = () => {
          stateActions.hideGlobalModal();
          history.goBack();
        };
        if (getAppState().isOnline && error.message.indexOf("timeout") > -1) {
          stateActions.showGlobalModal(
            getInternetConnectivityModalConfig.call(this, {
              retryImplementation: retry,
              backImplementation: back,
              needsDismissableProp: false,
              isTimeout: true
            })
          );
        } else if (!getAppState().isOnline && !error.status && !error.response) {
          stateActions.showGlobalModal(
            getInternetConnectivityModalConfig.call(this, {
              retryImplementation: retry,
              backImplementation: back
            })
          );
        } else {
          const buttons = [
            {
              ...getGlobalButtonInfo("retry"),
              buttonHandler: retry
            },
            {
              ...getGlobalButtonInfo("back"),
              buttonHandler: back
            }
          ];
          this.handleForcelogout(error);
          this.props.stateActions.showGlobalModal({

            modalText: i18n.get("global.errors.genericError"),
            buttons
          });
        }
        setFocus(getGlobalButtonFocusPath("retry"));
        return false;
      });
    } catch (error) {
      this.handleForcelogout(error);
    }

  }

  async handleForcelogout(error) {
    await this.props.stateActions.setForceLogout(error);
    // if Force logout show the popup
    if (!!getAppState().forceLogout) {
      this.props.resumeNavigation();
      await showForceLogoutError.call(this);
      return;
    }
  }

  async componentDidMount() {
    const { onRef, resumeNavigation, setFocus } = this.props;
    // Deep call of User Addons to get the payment info for each addons
    makeAddOnsDeep.call(this);

    trackPage(PAGE);
    onRef(this);
    resumeNavigation();
    this.loadData(() => {
      if (
        this.state.isEmpty ||
        !this.state.watchlist ||
        !this.state.watchlist.titles ||
        !this.state.watchlist.titles.length
      ) {
        this.props.setFocus("buttonMoviesPath");
      } else {
        setFocus(defaultFocusPath);
      }
    });
  }

  close4KModal() {
    this.setState({ modal4K: false });
    this.props.setFocus(defaultFocusPath);
  }

  get isReady() {
    const { watchlist, mystarzlist, isEmpty } = this.state;
    return watchlist && mystarzlist && !isEmpty;
  }

  render() {
    const { isLoading, watchlist, mystarzlist, isEmpty, modal4K } = this.state;
    return (
      <section>
        <HeadingStyled rank={1} text={i18n.get("pages.myLibrary.mytitle")} />
        {this.state.isLoading ? <Loading overlay /> : this.isReady ? (
          <Fragment>
            {this.loadCarousel(watchlist, WATCHLIST)}
            {this.loadCarousel(mystarzlist, MYSTARZLIST)}
          </Fragment>
        ) : !isEmpty ? (
          <Loading overlay />
        ) : (
          showNoContent(null, this.onClickButton, isAccessLimitedByParentalLevel())
        )}
        {modal4K && (
          <Modal mainText={i18n.get("global.4Ksupported")}>
            <ButtonModalFocus
              label={i18n.get("global.play4K")}
              focusPath="play4KModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, true)}
              onMouseUp={this.onEnterPlay.bind(this, true)}
              size="small"
              onRef={ref => (this.play4KModalFocusPath = ref)}
              dataSnUp={""}
              dataSnDown={""}
              dataSnLeft={i18n.directionFlip("", "@playHDModal_passThru")}
              dataSnRight={i18n.directionFlip("@playHDModal_passThru", "")}
            />
            <ButtonModalFocus
              label={i18n.get("global.playHD")}
              focusPath="playHDModal_passThru"
              onEnterPress={this.onEnterPlay.bind(this, false)}
              onMouseUp={this.onEnterPlay.bind(this, false)}
              size="small"
              dataSnUp={""}
              dataSnDown={""}
              dataSnLeft={i18n.directionFlip("@play4KModal_passThru", "")}
              dataSnRight={i18n.directionFlip("", "@play4KModal_passThru")}
            />
          </Modal>
        )}
      </section>
    );
  }
}

const MyLibrary = withAppState(
  withSubtheme(props => <MyLibraryPage currentFocus={props.applicationState.currentFocus} {...props} />)
);

MyLibrary.defaultFocusPath = defaultFocusPath;

export default MyLibrary;
